import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import orderingApi from "../../api/ordering/OrderApi";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../../components/OrderDetails/Header";
import CustomerCard from "../../components/OrderDetails/CustomerCard";
import AddressCard from "../../components/OrderDetails/AddressCard";

import ItemsList from "../../components/OrderDetails/ItemsList";
import PaymentSummary from "../../components/OrderDetails/PaymentSumary";
import Timeline from "../../components/OrderDetails/Timeline";
import Loading from "../../Util/Loading";
import RefundConfirmModal from "../../components/OrderDetails/RefundConfirmModal";

const OrderDetail = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundLoading, setRefundLoading] = useState(false);
  const [selectedRefundId, setSelectedRefundId] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchOrder = async () => {
      try {
        setIsLoading(true);

        const { response, err } = await orderingApi.getOrderById(id);

        const data = response?.data?.order || response?.data;

        if (!isMounted) return;

        if (data) {
          setOrder(data);
        } else if (err) {
          setError(err.message || "Failed to load order");
        }
      } catch {
        if (isMounted) setError("Unexpected error");
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    if (id) fetchOrder();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const handleUpdateStatus = async (id, status) => {
    const { response, err } = await orderingApi.updateOrderStatus({
      id,
      status,
    });

    if (response) {
      // 🔥 update local state (VERY IMPORTANT)
      setOrder(response.data.order);
    }

    if (err) {
      console.error(err);
    }
  };

  const openRefundModal = (id) => {
    setSelectedRefundId(id);
    setShowRefundModal(true);
  };

  // const handleRefund = async (id) => {
  //   try {
  //     const confirm = window.confirm("Are you sure you want to refund?");
  //     if (!confirm) return;

  //     const { response, err } = await orderingApi.refundOrder({ id });

  //     if (response) {
  //       // ✅ update UI immediately
  //       setOrder(response.data.order);
  //     }

  //     if (err) {
  //       console.error(err);
  //     }
  //   } catch (error) {
  //     console.error("Refund error:", error);
  //   }
  // };

  const handleRefund = async () => {
    console.log("refund id", selectedRefundId);

    try {
      setRefundLoading(true);

      const { response, err } = await orderingApi.refundOrder({
        id: selectedRefundId,
      });

      if (response) {
        setOrder(response.data.order);
        setShowRefundModal(false);
      }

      if (err) {
        console.error(err);
      }
    } catch (error) {
      console.error("Refund error:", error);
    } finally {
      setRefundLoading(false);
    }
  };

  if (!order)
    return (
      <Layout>
        <div className="min-h-screen">
          <Loading />
        </div>
      </Layout>
    );

  return (
    <Layout>
      <div className="max-w-4xl p-4 space-y-4 text-sm">
        <Header
          order={order}
          onUpdateStatus={handleUpdateStatus}
          onRefund={openRefundModal}
        />
        <CustomerCard order={order} />
        <AddressCard order={order} />
        <ItemsList order={order} />
        <PaymentSummary order={order} />
        <Timeline order={order} />
        <RefundConfirmModal
          isOpen={showRefundModal}
          onClose={() => setShowRefundModal(false)}
          onConfirm={handleRefund}
          isLoading={refundLoading}
        />
      </div>
    </Layout>
  );
};

export default OrderDetail;
